// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-prim {
    background-color: #1d09b2;
}

@media screen and (max-width: 500px) {
    .size {
        font-size: 12px;
        font-weight: 500;
    }
}

/*.container-height{
    height: 100vh;
    
}

.card-center{
    display: flex;
    justify-content: center;
}*/
/*main{
    background: #f3f4f6;
    grid-area: main;
    overflow-y: auto;
}

.main__container{
    padding: 20px 35px;
}

.main__title {
    display: flex;
    align-items: center;
}

.main__title > img{
    max-height: 100px;
    object-fit: contain;
    margin-right: 20px;
}

.main__greeting > h1{
    font-size: 24px;
    color: #2e4a66;
    margin-bottom: 5px;
}

.main__greeting > p{
    font-size: 14px;
    font-weight: 700;
    color: #a5aaad;
}

.main__cards{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin: 20px 0;
}

.card{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
    padding: 25px;
    border-radius: 5px;
    background-color: #fff;

    box-shadow: 5px 5px 13px #ededed, -5px -5px 13px #fff;
}

.card_inner{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card_inner > span{
    font-size: 25px;
}

.charts{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-top: 50px;
}

.charts__left{
    padding: 25px;
    border-radius: 5px;
    background: #fff;
    box-shadow: 5px 5px 13px #ededed, -5px -5px 13px #fff;
}

.charts__left__title{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.charts__left__title > div > h1{
    font-size: 24px;
    color: #2e4a66;
    margin-bottom: 5px;
}

.charts__left__title > div > p{
    font-size: 14px;
    font-weight: 700;
    color: #a5aaad;
}

.charts__left__title > i{
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    background: #ffc100;
    border-radius: 200px 0px 200px 200px;
    -moz-border-radius: 200px 0px 200px 200px;
    -webkit-border-radius: 200px 0px 200px 200px;
    border: 0px solid #000;
    padding: 15px;
}

.charts__right{
    padding: 25px;
    border-radius: 5px;
    background: #fff;
    box-shadow: 5px 5px 13px #ededed, -5px -5px 13px #fff;
}

.charts__right__title{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.charts__right__title > div > h1{
    font-size: 24px;
    color: #2e4a66;
    margin-bottom: 5px;
}

.charts__right__title > div > p{
    font-size: 14px;
    font-weight: 700;
    color: #a5aaad;
}

.charts__right__title > i{
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    background: #39447a;
    border-radius: 200px 0px 200px 200px;
    border: 0 solid #000;
    padding: 15px;
}

.charts__right__cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 30px;
}

.card1{
    background: #d1ecf1;
    color: #35a4ba;
    text-align: center;
    padding: 25px;
    border-radius: 5px;
    font-size: 14px;
}

.card2{
    background: #d1ecf1;
    color: #35a4ba;
    text-align: center;
    padding: 25px;
    border-radius: 5px;
    font-size: 14px;
}

.card3{
    background: #d1ecf1;
    color: #35a4ba;
    text-align: center;
    padding: 25px;
    border-radius: 5px;
    font-size: 14px;
}

.card4{
    background: #d1ecf1;
    color: #35a4ba;
    text-align: center;
    padding: 25px;
    border-radius: 5px;
    font-size: 14px;
}

@media only screen and (max-width: 855px){
    .main__cards{
        grid-template-columns: 1fr;
        gap: 10px;
        margin-bottom: 0;
    }

    .charts{
        grid-template-columns: 1fr;
        margin-top: 30px;
        justify-content: center;
    }

    .charts__right__cards {
        grid-template-columns: 1fr;
        align-items: center;
        margin-top: 30px;
    }
}*/
/* Home.css */
.card-link {
    text-decoration: none;
  }
  
  .card-link .card-hover {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .card-link:hover .card-hover {
    transform: scale(1.05); /* Aumenta o tamanho do card */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Adiciona uma sombra */
  }`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;;;;;;;;EAQE;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0ME;AACF,aAAa;AACb;IACI,qBAAqB;EACvB;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,sBAAsB,EAAE,8BAA8B;IACtD,wCAAwC,EAAE,wBAAwB;EACpE","sourcesContent":[".bg-prim {\n    background-color: #1d09b2;\n}\n\n@media screen and (max-width: 500px) {\n    .size {\n        font-size: 12px;\n        font-weight: 500;\n    }\n}\n\n/*.container-height{\n    height: 100vh;\n    \n}\n\n.card-center{\n    display: flex;\n    justify-content: center;\n}*/\n/*main{\n    background: #f3f4f6;\n    grid-area: main;\n    overflow-y: auto;\n}\n\n.main__container{\n    padding: 20px 35px;\n}\n\n.main__title {\n    display: flex;\n    align-items: center;\n}\n\n.main__title > img{\n    max-height: 100px;\n    object-fit: contain;\n    margin-right: 20px;\n}\n\n.main__greeting > h1{\n    font-size: 24px;\n    color: #2e4a66;\n    margin-bottom: 5px;\n}\n\n.main__greeting > p{\n    font-size: 14px;\n    font-weight: 700;\n    color: #a5aaad;\n}\n\n.main__cards{\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 30px;\n    margin: 20px 0;\n}\n\n.card{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 70px;\n    padding: 25px;\n    border-radius: 5px;\n    background-color: #fff;\n\n    box-shadow: 5px 5px 13px #ededed, -5px -5px 13px #fff;\n}\n\n.card_inner{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.card_inner > span{\n    font-size: 25px;\n}\n\n.charts{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n    margin-top: 50px;\n}\n\n.charts__left{\n    padding: 25px;\n    border-radius: 5px;\n    background: #fff;\n    box-shadow: 5px 5px 13px #ededed, -5px -5px 13px #fff;\n}\n\n.charts__left__title{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.charts__left__title > div > h1{\n    font-size: 24px;\n    color: #2e4a66;\n    margin-bottom: 5px;\n}\n\n.charts__left__title > div > p{\n    font-size: 14px;\n    font-weight: 700;\n    color: #a5aaad;\n}\n\n.charts__left__title > i{\n    font-size: 20px;\n    font-weight: 700;\n    color: #fff;\n    background: #ffc100;\n    border-radius: 200px 0px 200px 200px;\n    -moz-border-radius: 200px 0px 200px 200px;\n    -webkit-border-radius: 200px 0px 200px 200px;\n    border: 0px solid #000;\n    padding: 15px;\n}\n\n.charts__right{\n    padding: 25px;\n    border-radius: 5px;\n    background: #fff;\n    box-shadow: 5px 5px 13px #ededed, -5px -5px 13px #fff;\n}\n\n.charts__right__title{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.charts__right__title > div > h1{\n    font-size: 24px;\n    color: #2e4a66;\n    margin-bottom: 5px;\n}\n\n.charts__right__title > div > p{\n    font-size: 14px;\n    font-weight: 700;\n    color: #a5aaad;\n}\n\n.charts__right__title > i{\n    font-size: 20px;\n    font-weight: 700;\n    color: #fff;\n    background: #39447a;\n    border-radius: 200px 0px 200px 200px;\n    border: 0 solid #000;\n    padding: 15px;\n}\n\n.charts__right__cards {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    margin-top: 30px;\n}\n\n.card1{\n    background: #d1ecf1;\n    color: #35a4ba;\n    text-align: center;\n    padding: 25px;\n    border-radius: 5px;\n    font-size: 14px;\n}\n\n.card2{\n    background: #d1ecf1;\n    color: #35a4ba;\n    text-align: center;\n    padding: 25px;\n    border-radius: 5px;\n    font-size: 14px;\n}\n\n.card3{\n    background: #d1ecf1;\n    color: #35a4ba;\n    text-align: center;\n    padding: 25px;\n    border-radius: 5px;\n    font-size: 14px;\n}\n\n.card4{\n    background: #d1ecf1;\n    color: #35a4ba;\n    text-align: center;\n    padding: 25px;\n    border-radius: 5px;\n    font-size: 14px;\n}\n\n@media only screen and (max-width: 855px){\n    .main__cards{\n        grid-template-columns: 1fr;\n        gap: 10px;\n        margin-bottom: 0;\n    }\n\n    .charts{\n        grid-template-columns: 1fr;\n        margin-top: 30px;\n        justify-content: center;\n    }\n\n    .charts__right__cards {\n        grid-template-columns: 1fr;\n        align-items: center;\n        margin-top: 30px;\n    }\n}*/\n/* Home.css */\n.card-link {\n    text-decoration: none;\n  }\n  \n  .card-link .card-hover {\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .card-link:hover .card-hover {\n    transform: scale(1.05); /* Aumenta o tamanho do card */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Adiciona uma sombra */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
